<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      title="查看图片"
      width="600px"
      top="5vh">
    <div
        v-for="item in pictureList"
        :key="item.pkid">
      <span style="position: relative">
        <img width="200px" height="200px" :src="getPhotoPath(item.photoPath)" @click.self="showBigImage($event)">
        <div style="position: absolute;bottom: 10px;left: 50%;transform: translateX(-50%);color: white">{{pcNo}}</div>
      </span>
    </div>

    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        :pc-no="pcNo"
        @closeClick="photoVisible = false"/>
  </el-dialog>
</template>

<script>

  import BigImg from "@/components/BigImg";
  export default {
    name:"PictureList",
    components: {BigImg},
    data() {
      return {
        photoVisible: false,
        bigImgUrl: "",
        pcNo: "",
        dialogVisible: false,
        pictureList:[],
      };
    },
    methods: {
      open(photos,techParamBillNo) {
        console.log(photos);
        this.dialogVisible = true;
        this.pictureList = photos;
        this.pcNo = techParamBillNo;
      },
      getPhotoPath(path) {
        return  window.config.basicServerHttpUrl + "file/download?uuid=" + path+"&name=" + "PIC.jpeg";
      },
      showBigImage(e) {
        //点击图片函数，点击后，把photoVisible设置成true
        if (e != "") {
          this.photoVisible = true;
          this.bigImgUrl = e.currentTarget.src;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
